import { Country } from './types';

const CanadianPostalCode = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
const USAPostalCode = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

export const countryByPostalCode = (postalCode: string): Country =>
  CanadianPostalCode.test(postalCode) ? 'CAN' : 'USA';

export const validatePostalCode = (postalCode: string): boolean => USAPostalCode.test(postalCode) || CanadianPostalCode.test(postalCode);
